import "./index.scss";
import { ReactHelmetWithProvider } from "providers/ReactHelmetProvider";
import { PartnershipsHeader } from "components/UI/organisms";
import { PartnershipsBenefits } from "components/UI/molecules";

export const Partnerships = () => (
  <div className="partnerships">
    <ReactHelmetWithProvider>
      <title>Brand Partnership Program - GCX</title>
    </ReactHelmetWithProvider>
    <PartnershipsHeader />
    <PartnershipsBenefits />
  </div>
);
